import { BaseService, Service } from "/@/cool";
@Service("dealerShopAgent")
class dealerShopAgent extends BaseService {
	constructor() {
		super();

		let prefix = "";
		if (this.namespace) {
			prefix = this.namespace.replace(/\//g, ":") + ":";
		}

		this.permission["add"] = prefix + "add";
		this.permission["update"] = prefix + "update";
		this.permission["info"] = prefix + "info";
		this.permission["page"] = prefix + "page";
		this.permission["updatePriceVersion"] = prefix + "updatePriceVersion";
		this.permission["updateProfitSharingVersion"] = prefix + "updateProfitSharingVersion";
		this.permission["updateVersion"] = prefix + "updateVersion";
		this.permission["bindDot"] = prefix + "bindDot";
		this.permission["dotUserQuery"] = prefix + "dotUserQuery";
		this.permission["getQrcode"] = prefix + "getQrcode";
	}

	agentPage(params: any) {
		return this.request({
			url: "/agentPage",
			method: "POST",
			data: { ...params }
		});
	}

	updatePriceVersion(params: any) {
		return this.request({
			url: "/updatePriceVersion",
			method: "POST",
			data: { ...params }
		});
	}

	updateProfitSharingVersion(params: any) {
		return this.request({
			url: "/updateProfitSharingVersion",
			method: "POST",
			data: { ...params }
		});
	}

	updateVersion(params: any) {
		return this.request({
			url: "/updateVersion",
			method: "POST",
			data: { ...params }
		});
	}

	// 绑定用户
	bindDot(params: any) {
		return this.request({
			url: "/bindDot",
			method: "POST",
			data: { ...params }
		});
	}

	// 查询用户
	dotUserQuery(params: any) {
		return this.request({
			url: "/dotUserQuery",
			method: "POST",
			data: { ...params }
		});
	}

	// 获取二维码接口
	getQrcode(params: any) {
		return this.request({
			url: "/getQrcode",
			method: "POST",
			data: { ...params }
		});
	}
}
export default dealerShopAgent;
